<template>
  <v-card v-if="chartObj">
    <v-card-title class="pa-2">
      <div class="subheading">
        <v-icon class="mr-2">table_chart</v-icon>
        {{ chartObj.title }}
        <div style="display:none;">
          {{chartKey}}
        </div>
      </div>
      <v-spacer></v-spacer>
      <filter-date-time-comparison v-if="comparisonPeriod && chartObj.data.result && chartObj.data.result.length"
                                   @update-filter-date-time-comparison="updateTableData($event)">
      </filter-date-time-comparison>
      <div class="export-menu"
           v-if="chartObj.data.result && chartObj.data.result.length
                 && chartObj.export && chartObj.exportTo && chartObj.exportTo.length">
        <export-chart-menu
          :chart-obj="chartObj"
          :comparison-period="comparisonPeriod"
          :date-time-comparison="dateTimeComparison"
          :set-ef-feature-id="true">
        </export-chart-menu>
      </div>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <div class="table-wrapper">
        <chart-table-render
          :comparison-period="comparisonPeriod"
          :date-time-comparison="dateTimeComparison"
          :footer-data="tableTotal"
          :chart-key="chartKey"
          :hide-pagination="hidePagination"
          @update-pagination="paginationUpdated($event)">
        </chart-table-render>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { eventBus } from '@/eventBus'
import { mapActions } from 'vuex'
import ChartTableRender from '@/components/charts/ChartTableRender'
import ExportChartMenu from '@/components/charts/ExportChartMenu'
import FilterDateTimeComparison from '@/components/filters/FilterDateTimeComparisonGenLocal'

export default {
  name: 'chartTable',
  components: {
    ChartTableRender,
    ExportChartMenu,
    FilterDateTimeComparison
  },
  props: {
    chartKey: { type: String, required: true },
    comparisonPeriod: { type: Boolean },
    tableTotal: { type: Object },
    hidePagination: { type: Boolean }
  },
  data () {
    return {
      pagination: null,
      dateTimeComparison: []
    }
  },
  computed: {
    chartObj: {
      get () { return this.$store.getters.getChartByKey(this.chartKey) }
    }
  },
  created () {
    this.$log.info('chartobject', this.chartObj)
    eventBus.$on('update-dashboard', () => {
      if (!this.comparisonPeriod) {
        this.fetchChartData({
          key: this.chartObj.key,
          settings: this.chartObj.chartSettings,
          filters: this.$store.getters.isGenericGen ? this.$store.getters.selectedFiltersGen : this.$store.getters.selectedFilters,
          pagination: this.chartObj.pagination
        })
      } else {
        this.fetchChartData({
          key: this.chartObj.key,
          settings: this.chartObj.chartSettings,
          filters: this.$store.getters.isGenericGen ? this.$store.getters.selectedFiltersGen : this.$store.getters.selectedFilters,
          pagination: this.chartObj.pagination,
          date_time_comparison: this.dateTimeComparison
        })
      }
    })
  },
  destroyed () {
    eventBus.$off('update-dashboard')
  },
  methods: {
    ...mapActions(['fetchChartData']),
    paginationUpdated (pagination) {
      // update pagination in store
      this.$store.commit('SET_CHART_PAGINATION', pagination)

      // fetch table data based on new pagination
      if (!this.comparisonPeriod) {
        this.fetchChartData({
          key: pagination.key,
          filters: this.$store.getters.isGenericGen ? this.$store.getters.selectedFiltersGen : this.$store.getters.selectedFilters,
          pagination: pagination.pagination
        })
      } else {
        this.fetchChartData({
          key: pagination.key,
          filters: this.$store.getters.isGenericGen ? this.$store.getters.selectedFiltersGen : this.$store.getters.selectedFilters,
          pagination: pagination.pagination,
          date_time_comparison: this.dateTimeComparison
        })
      }
    },
    updateTableData (dateTimeComparison) {
      this.dateTimeComparison = dateTimeComparison

      this.fetchChartData({
        key: this.chartKey,
        filters: this.$store.getters.isGenericGen ? this.$store.getters.selectedFiltersGen : this.$store.getters.selectedFilters,
        pagination: this.$store.getters.getChartByKey(this.chartKey).pagination,
        date_time_comparison: this.dateTimeComparison
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .table-wrapper {}
</style>
